// Simple Mega Menu Hover - Minimal Solution
document.addEventListener('DOMContentLoaded', function() {
  const isDesktop = () => window.innerWidth >= 990;
  
  // Get all header menu elements
  const headerMenus = document.querySelectorAll('header-menu');
  
  headerMenus.forEach(menu => {
    const details = menu.querySelector('details.mega-menu');
    const summary = menu.querySelector('summary');
    
    if (!details || !summary) return;
    
    // Prevent click on desktop
    summary.addEventListener('click', function(e) {
      if (isDesktop()) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
    
    // Open on mouse enter (desktop only)
    menu.addEventListener('mouseenter', function() {
      if (isDesktop()) {
        details.setAttribute('open', 'true');
      }
    });
    
    // Close on mouse leave (desktop only)
    menu.addEventListener('mouseleave', function() {
      if (isDesktop()) {
        details.removeAttribute('open');
      }
    });
  });
});